import {SActionBtn, SLowcodeList, SMessage, STableActions} from "shj-components";
import {message, Switch} from "antd";

import {config} from "./config.tsx";
import {useNavigate} from "react-router-dom";
import {
  getProductEnums,
  getSubItemManagementPage, subItemManagementDelete,
  subItemManagementUpdateState
} from "@/services/product.ts";
import {apiData2Table} from "@/utils/data.ts";
import {useRef} from "react";

const SubItemList = () => {
  const navigate = useNavigate()
  const listRef = useRef();
  const fetchList = ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      getSubItemManagementPage({params: {pageId: current, pageSize}, data: {...query, orderBys: [{columnName: 'id', asc: false}]}}).then(res => {
        resolve(apiData2Table(res))
      }).catch(reject)
    })
  }

  const onChangeStatus = (enabled: boolean, id: string) => {
    SMessage.confirm({
      title: `${enabled ? '打开' : '关闭'}开关，将${enabled ? '启用' : '禁用'}子项，是否继续？`,
      okText: '继续',
      content: null,
      onOk: () => {
        return subItemManagementUpdateState({idList: [id], enabled}).then((res: any) => {
          message.success(res.message || '操作成功');
          listRef.current?.reload()
        })
      },
    });
  }

  const onDel = id => {
    SMessage.confirm({
      onOk: () => {
       return subItemManagementDelete(id).then((res: any) => {
          message.success(res.message || '操作成功');
          listRef.current?.reload()
        })
      },
    });
  }

  const onAddOrEdit = (id: string | number = 0) => {
    navigate('/config/baseProduct/subItemList/addOrEdit/' + (id ? id : ''))
  }

  const onDetail = (id: string) => {
    navigate('/config/baseProduct/subItemList/detailList/' + id)
  }

  const getStatusOptions = async() => {
    const statueEnum = await getProductEnums('com.shj.saas.plus.product.enums.StatueEnum')
    return Promise.resolve({statueEnum})
  }

  const extensions = {
    request: {fetchList, getStatusOptions},
    events: {onAdd: () => onAddOrEdit()},
    customRender: {
      switchRender(v: boolean, record: Record<string, any>) {
        return <Switch checkedChildren="启用" unCheckedChildren="禁用"
                       checked={v} onClick={(checked) => onChangeStatus(checked, record.id)}/>
      },
      actionRender(_: null, record: Record<string, any>) {
        return <STableActions>
          <SActionBtn onClick={() => onDetail(record.id)}>详情</SActionBtn>
          <SActionBtn onClick={() => onAddOrEdit(record.id)}>编辑</SActionBtn>
          {!record.enabled && <SActionBtn danger onClick={() => onDel(record.id)}>删除</SActionBtn>}
        </STableActions>
      }
    }
  }
  return (
      <div>
        <SLowcodeList
            ref={listRef}
            searchMode={'group'}
            config={config}
            {...extensions}
        />
      </div>
  );
};

export default SubItemList;